import { Moment } from 'moment/moment';

export class PlanwertFilter {
    constructor(
        public netzbetreiberName?: string,
        public stadtwerkeId?: string,
        public erzeugungsanlageDokumentenId?: string,
        public erzeugungsanlageTechnischeResourceId?: string,
        public erzeugungsanlageBezVnbIntern?: string,
        public netzzuordnungNetzverknuepfungspunkte?: string,
        public dataTransferDate?: {
            start?: Moment,
            end?: Moment,
        },
        public type?: string[],
        public status?: string[],
    ) {
    }
}
